/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_LoginInputs */

const en_nav_login = /** @type {(inputs: Nav_LoginInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Login`)
};

const es_nav_login = /** @type {(inputs: Nav_LoginInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iniciar sesión`)
};

const de_nav_login = /** @type {(inputs: Nav_LoginInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anmelden`)
};

const zh_nav_login = /** @type {(inputs: Nav_LoginInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`登录`)
};

const ar_nav_login = /** @type {(inputs: Nav_LoginInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تسجيل الدخول`)
};

const fr_nav_login = /** @type {(inputs: Nav_LoginInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Se connecter`)
};

const vi_nav_login = /** @type {(inputs: Nav_LoginInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đăng nhập`)
};

const sw_nav_login = /** @type {(inputs: Nav_LoginInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingia`)
};

const th_nav_login = /** @type {(inputs: Nav_LoginInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เข้าสู่ระบบ`)
};

const bs_nav_login = /** @type {(inputs: Nav_LoginInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prijava`)
};

const ja_nav_login = /** @type {(inputs: Nav_LoginInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ログイン`)
};

const ko_nav_login = /** @type {(inputs: Nav_LoginInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`로그인`)
};

const pt_nav_login = /** @type {(inputs: Nav_LoginInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entrar`)
};

const it_nav_login = /** @type {(inputs: Nav_LoginInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accedi`)
};

const sv_nav_login = /** @type {(inputs: Nav_LoginInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Logga in`)
};

const nl_nav_login = /** @type {(inputs: Nav_LoginInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aanmelden`)
};

const da_nav_login = /** @type {(inputs: Nav_LoginInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Log ind`)
};

const nb_nav_login = /** @type {(inputs: Nav_LoginInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Logg inn`)
};

const fi_nav_login = /** @type {(inputs: Nav_LoginInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kirjaudu sisään`)
};

const pl_nav_login = /** @type {(inputs: Nav_LoginInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zaloguj`)
};

const ru_nav_login = /** @type {(inputs: Nav_LoginInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вход`)
};

const tr_nav_login = /** @type {(inputs: Nav_LoginInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Giriş`)
};

const hi_nav_login = /** @type {(inputs: Nav_LoginInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`लॉग इन`)
};

const id_nav_login = /** @type {(inputs: Nav_LoginInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Masuk`)
};

const ms_nav_login = /** @type {(inputs: Nav_LoginInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Log masuk`)
};

const cs_nav_login = /** @type {(inputs: Nav_LoginInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Přihlášení`)
};

const el_nav_login = /** @type {(inputs: Nav_LoginInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Σύνδεση`)
};

const he_nav_login = /** @type {(inputs: Nav_LoginInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`כניסה`)
};

const af_nav_login = /** @type {(inputs: Nav_LoginInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teken in`)
};

const hu_nav_login = /** @type {(inputs: Nav_LoginInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bejelentkezés`)
};

/**
* | output |
* | --- |
* | "Login" |
*
* @param {Nav_LoginInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const nav_login = /** @type {((inputs?: Nav_LoginInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_LoginInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_nav_login(inputs)
	if (locale === "de") return de_nav_login(inputs)
	if (locale === "zh") return zh_nav_login(inputs)
	if (locale === "ar") return ar_nav_login(inputs)
	if (locale === "fr") return fr_nav_login(inputs)
	if (locale === "vi") return vi_nav_login(inputs)
	if (locale === "sw") return sw_nav_login(inputs)
	if (locale === "th") return th_nav_login(inputs)
	if (locale === "bs") return bs_nav_login(inputs)
	if (locale === "ja") return ja_nav_login(inputs)
	if (locale === "ko") return ko_nav_login(inputs)
	if (locale === "pt") return pt_nav_login(inputs)
	if (locale === "it") return it_nav_login(inputs)
	if (locale === "sv") return sv_nav_login(inputs)
	if (locale === "nl") return nl_nav_login(inputs)
	if (locale === "da") return da_nav_login(inputs)
	if (locale === "nb") return nb_nav_login(inputs)
	if (locale === "fi") return fi_nav_login(inputs)
	if (locale === "pl") return pl_nav_login(inputs)
	if (locale === "ru") return ru_nav_login(inputs)
	if (locale === "tr") return tr_nav_login(inputs)
	if (locale === "hi") return hi_nav_login(inputs)
	if (locale === "id") return id_nav_login(inputs)
	if (locale === "ms") return ms_nav_login(inputs)
	if (locale === "cs") return cs_nav_login(inputs)
	if (locale === "el") return el_nav_login(inputs)
	if (locale === "he") return he_nav_login(inputs)
	if (locale === "af") return af_nav_login(inputs)
	if (locale === "hu") return hu_nav_login(inputs)
	return en_nav_login(inputs)
});